<template>
    <el-footer class="m-footer vh-center" >
        <div class="foot_box">
            <p>©2018-2022 易达云图（深圳）科技有限公司 版权所有 <a href="https://beian.miit.gov.cn/" style="color: #fff">辽ICP备19009716号</a></p>
        </div>
    </el-footer>
</template>

<script>
    export default {
        name: 'vfooter',
        data() {
            return {
            }
        },
        components: {

        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import '../style/variable';
    .m-footer{
        width: 100%;
        height: 40px;
        line-height: 40px;
        .foot_box{
            width: 550px;
            border-top: 1px solid $c3;
            text-align: center;
            font-size: 12px;
            color: $c1;
            line-height:39px;
        }
    }
</style>
